// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__menu__X2GmG {
  padding-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/SideBar/SideBarContent/index.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB","sourcesContent":[".menu {\n  padding-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `index-module__menu__X2GmG`
};
export default ___CSS_LOADER_EXPORT___;
